import { AdminCatalogProductImage } from '../../../api/types';
import { CatalogPhoto } from './CatalogPhoto';

export function CatalogMediaPhoto({ photo, name }: { photo: AdminCatalogProductImage; name: string }) {
  const isProcessing = photo.link_image_is_published === false || photo.link_pending_file_id != null;
  const isFailed = photo.link_processing_status === 'failed';
  return <div className="catalog-media-photo">
    {photo.link_image_is_published !== false ? <CatalogPhoto fileId={photo.link_file_id} image={photo.image} name={name} /> : <div className="catalog-photo-empty"><span>Фото</span></div>}
    {isProcessing ? <p className="catalog-media-photo__status" role="status">{isFailed ? 'Не удалось обработать фото. Загрузите его повторно.' : 'Подготавливаем изображение…'}</p> : null}
  </div>;
}
